export default __webpack_public_path__ + "static/media/servicio-facial.fa3a8f39.jpg";